import { useMemo } from "react";
import { useConfig } from "../../config/configContext";
import { convertSecondsToDurationString_Text, convertSecondsToLocal_HH_MM } from "../../utils/time";
import { Session } from "../../config/parsedConfig";

const DISPLAY_DURATION_TILL_UPCOMING_SESSION = 5 * 60; //5 minutes

export const UpcomingSessionInfo = (
    { upcomingSession, upcomingSessionIsTomorrow, roomColor, timeUntilUpcomingSession }:
        { upcomingSession: Session, upcomingSessionIsTomorrow: boolean, timeUntilUpcomingSession: number, roomColor: string }
) => {
    const config = useConfig();

    const upcomingSessionLocalTime = useMemo(() => {
        return convertSecondsToLocal_HH_MM(upcomingSession.startTime, upcomingSessionIsTomorrow, config.timezone);
    }, [upcomingSession, upcomingSessionIsTomorrow, config.timezone]);

    return (<p>
        Gerade ist Pause!<br />
        <span className="text-bold" style={{ color: roomColor }}>{upcomingSession.name}</span><br />
        {timeUntilUpcomingSession < DISPLAY_DURATION_TILL_UPCOMING_SESSION
            ? <span>
                startet in <span className="text-bold" >{convertSecondsToDurationString_Text(timeUntilUpcomingSession)}</span>.
            </span>
            : <span>
                startet {upcomingSessionLocalTime.locallyTomorrow && <span className="text-bold" >morgen</span>} um <span className="text-bold" >{upcomingSessionLocalTime.localTime} Uhr</span>.
            </span>
        }
    </p>);
};